import { Text } from '@chakra-ui/react';
import TextSection from '@components/articles/SeoTextSection';
import { fontSize } from '@constants/styles';
import CoverageOutline from './CoverageOutline';
import Plans from './Plans';

const coverage = [
  { covered: true, name: 'Part A Coinsurance' },
  { covered: true, name: 'Part A Hospice Care Coinsurance + Copay' },
  { covered: true, name: 'Part A Deductible' },
  { covered: true, name: 'Blood (3 Pints)' },
  { covered: true, name: 'Part B Coinsurance + Copay' },
  { covered: false, name: 'Part B Excess Charge' },
  { covered: false, name: 'Part B Deductible' },
];

const PlanN = ({ renderCta, name, carriers, averagePremium }) => (
  <>
    <TextSection title={`Should I even consider Plan N in ${name}?`}>
      <Text fontSize={fontSize.p}>
        This depends on your situation. In {name}, excess charges are outlawed. That means doctors cannot bill above the
        Medicare approved rate for a procedure. So if you’re on Plan N, that “gap” in coverage is generally not one you
        need to worry about. The exception is if you frequently travel or visit another state where they excess charges
        are legal (in 42 states, they are). We can also help you decide between Plan G and Plan N your specific case.
      </Text>
      <Text fontSize={fontSize.p}>
        The average monthly premium for Plan N in {name} is ${averagePremium.toFixed(2)}. Same as the other Medicare
        Supplements, the Plan N we suggest for our clients is the one with the lowest premium, which we’ve included in
        the Top 10 list below.
      </Text>
      <Text fontSize={fontSize.p}>
        If you don’t travel out of state frequently, and premiums in your zip code are lower than those for Plan G, Plan
        N may be right for you. Take a look at what that entails below:
      </Text>
      <CoverageOutline coverage={coverage} />
    </TextSection>
    <TextSection title={`Top 10 Cheapest Plan N Options in ${name}:`}>
      <Plans plans={carriers} />
      <Text fontSize={fontSize.p}>
        Premiums do vary by zip code, so contact us below to hear the local premiums you can actually enroll in.
      </Text>
      {renderCta()}
    </TextSection>
  </>
);

export default PlanN;
